export default "__VITE_ASSET__BKV3mcwS__"